import { Injectable } from '@angular/core';
import { EngravingType } from 'src/app/interfaces/engraving-type';
import { APIProviderService } from '../api/api.provider.service';

@Injectable({
  providedIn: 'root'
})
export class EngravingTypesProviderService extends APIProviderService<EngravingType> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/EngravingTypes`;
  }
}
